// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2qhix","filesListContainer":"PosDisputesFiles_filesListContainer__282Hy","filesButton":"PosDisputesFiles_filesButton__2aW-T"};